import React, { useEffect } from 'react'
import ShopStore from '../DataRepo/ShopStore';
import WishlistStore from '../DataRepo/WishlistStore';
import loadingimg from '../Assets/images/loading image 1.png'
import { CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';

function TestKit() {

    const { getTestKitProducts, AllTestKitProducts, isAllTestKitProductsLoading } = ShopStore();

    const navigate = useNavigate()

    const { addWishlist, WishlistItems, isWishlistLoading, removeWishlist, getWishlistItems, } = WishlistStore()


    useEffect(() => {
        getTestKitProducts()
    }, [])

    return <div className='Shop-main-section'>

        <div className='mt-5 TestKit-Products-landing-section'>

            <div>
                {isAllTestKitProductsLoading ? <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100vw", height: '100vh' }}>
                    <div style={{ position: "relative", width: "10rem", height: "10rem" }}>
                        <CircularProgress style={{ width: "100%", height: "100%", color: "#DA6E0B" }} thickness={1} />
                        <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, display: "flex", justifyContent: "center", alignItems: "center" }}>
                            <img src={loadingimg} style={{ width: "80%", height: "80%" }} alt="Loading" />
                        </div>
                    </div>
                </div> :

                    AllTestKitProducts.map((e, i) => {
                        return <div className='flex flex-col bg-[#EFEFE7]' style={{ padding: '10px 1rem' }}>
                            {i == 0 ? <div className=''>
                                <h2 className='text-header-text text-2xl'>Engineer Your Gut Health</h2>
                            </div> : <div className=''>
                                <h2 className='text-header-text text-2xl'>Improve metabolic health in 7 days</h2>
                            </div>}
                            <div className='Top-Products-landing-sectionpcardtestkit' key={i} onClick={() => {
                                navigate(`/TestKitPage?id=${e?.id}`)
                            }}>


                                <div>
                                    <img src={e?.imgurl}></img>
                                </div>

                                <div>

                                    <p className='text-xl'>{e?.name}</p>
                                    <p className='text-md'>{e?.desc}</p>

                                    <p className='text-md text-[#DA6E0B]'>Free Doctor Consultation</p>
                                    <p
                                        style={{
                                            background: '#E8F5E9',
                                            color: '#2E7D32',
                                            width: 'fit-content',
                                            fontSize: '12px',
                                            fontWeight: 600,
                                            padding: '8px 10px',
                                            borderRadius: '20px',
                                            fontFamily: "'Poppins', sans-serif"
                                        }}
                                    >
                                        Get Additional 10% Off on first time purchase
                                    </p>

                                    <div className='Product-section-price-details flex flex-row gap-5 text-xl'>
                                        {e?.orgprice > 0 && <p className='text-[#7C7870]'><del>{`₹${e?.orgprice}`}</del></p>}
                                        <p className='text-[#75623F] font-bold'>₹{e?.price}</p>
                                    </div>

                                </div>

                            </div>
                        </div>
                    })
                }
            </div>
        </div>
    </div>
}

export default TestKit